import MimeTypeIcon from './MimeTypeIcon';

export default MimeTypeIcon;
